export default {
  ApplicationInfo: 'Informations',
  Game: 'Jeu',
  Account: 'Compte',
  Server: 'Serveur',
  CharacterName: 'Nom de Personnage',
  PlatformOrderNumber: 'Numéro de Commande de Plateforme',
  Amount: 'Montant',
  InvoiceMethod: 'Détails de Facture',
  InvoiceByTotalOrderAmount:
    'Émettre une facture correspondant au montant total de plusieurs commandes',
  InvoiceByOrderAmountSeparately:
    'Émettre des factures séparées pour plusieurs commandes en fonction du montant de chaque commande',
  PhoneNumber: 'Numéro de Contact',
  Name: 'Nom',
  Address: 'Adresse du Destinataire',
  InvoiceTitle: 'Facturer à',
  PersonalTitleOnlyNoCompany:
    "Veuillez saisir votre nom. Ne saisissez pas le nom d'une entreprise ou d'une organisation.",
  ReceivingEmail: 'Adresse e-mail',
  Remarks: 'Remarque',
  InputContent: 'Saisir ici',
  ApplicationSubmittedSuccessfully: 'Demande soumise',
  InvoiceApplicationSubmittedSuccessfully:
    'Votre demande de facture a été soumise.\r\nNotre équipe la traitera dans les 7 jours ouvrables, veuillez vérifier votre messagerie.',
  Confirm: 'Confirmer',
  Submit: 'Soumettre',
  ApplicationSubmissionFailed: 'Échec de la soumission de la demande',
  InvoiceApplicationFailed:
    "Votre demande de facture n'a pas été soumise. Veuillez actualiser et réessayer ou contacter le service client.",
  InvoiceApplicationSubmitted:
    'Votre demande a été soumise. Veuillez ne pas la soumettre à nouveau.',
  PleaseEnterName: 'Veuillez saisir votre nom',
  PleaseEnterAddress: "Veuillez saisir l'adresse",
  PleaseEnterInvoiceTitle: 'Veuillez saisir le nom du destinataire',
  PleaseEnterEmail: "Veuillez saisir l'adresse e-mail",
  PleaseEnterRemarks: 'Veuillez saisir une note si nécessaire',
  NumberParsingError: 'Numéro invalide',
  PleaseEnterValidEmailFormat: 'Veuillez saisir une adresse e-mail valide',
  IncompleteInformation: 'Informations incomplètes, veuillez vérifier',
  ExpandAll: 'Tout Afficher'
};
